<template>
  <el-dialog
    :title="isCreate ? '新增定时促销' : '编辑定时促销'"
    :visible="true"
    width="66.666666%"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="140px"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="定时促销名称" prop="scheduleName">
            <el-input
              v-model.trim="ruleForm.scheduleName"
              type="text"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="定时促销折扣(%)" prop="zhekou">
            <el-input-number
              v-model.trim="ruleForm.zhekou"
              :step="5"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="12">
          <el-form-item label="最低消费金额" prop="minimalAmount">
            <el-input
              v-model.trim="ruleForm.minimalAmount"
              type="text"
            ></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="有效日" prop="checkedWeek">
            <el-checkbox-group v-model="ruleForm.checkedWeek">
              <el-checkbox v-for="item in weeks" :label="item" :key="item">{{
                translateItem(item)
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <agentVendorShop @select="selectHandler" v-if="isCreate" />
        <agentVendorShop
          @select="selectHandler"
          :initData="selectedAvs"
          @init="initHandler"
          v-else
        />
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="是否启用">
            <el-switch v-model="ruleForm.isEnable"> </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :rows="3"
              v-model.trim="ruleForm.remark"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="起止时间" prop="timeRange">
            <el-time-picker
              is-range
              value-format="HH:mm"
              v-model="ruleForm.timeRange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
            >
            </el-time-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
//import { mapGetters } from "vuex";
import Promotion from "../../../plugins/PromotionClass";
import agentVendorShop from "@/components/layout/agentVendorShop";

export default {
  props: ["isCreate", "promotionItem"],
  components: {
    agentVendorShop
  },
  data() {
    const promotionObj = this.isCreate ? new Promotion() : this.promotionItem;
    console.log(promotionObj);
    if (!this.isCreate) {
      promotionObj.checkedWeek = [];
      promotionObj.timeRange = [];
      Array.of(1, 2, 4, 8, 16, 32, 64).forEach(ele => {
        if ((promotionObj.day & ele) === ele) {
          promotionObj.checkedWeek.push(ele);
        }
      });
      promotionObj.timeRange = [promotionObj.startTime, promotionObj.endTime];

      this.selectedAvs = {
        selectedAgentid: promotionObj.agentid,
        selectedVendorid: promotionObj.vendorid,
        selectedShopid: promotionObj.shopid
      };
      console.log(this.selectedAvs);
    }

    return {
      // vendorsList: [],
      // shopList: [],
      vendorListForPrompt: [],
      shopListForPrompt: [],
      weeks: [1, 2, 4, 8, 16, 32, 64],
      checkedWeek: [],
      selectedAvs: {},
      ruleForm: {
        vendorName: this.$getVendorName(promotionObj.vendorid),
        shopName: "",
        ...promotionObj
      },
      rules: {
        scheduleName: [{ required: true, message: "请输入促销名称" }],
        zhekou: [
          { required: true, message: "请输入折扣率百分比" },
          {
            pattern: /^(0|[1-9]\d?|100)$/,
            message: "请输入正确的数字"
          }
        ],
        minimalAmount: [
          { required: true, message: "请输入最低消费金额" },
          {
            pattern: /^\d{0,}(\.\d{1,2})?$/,
            message: "请输入正确的数字"
          }
        ],
        checkedWeek: [{ required: true, message: "请选择至少一天" }],
        timeRange: [{ required: true, message: "请选择起止时间" }],
        vendorid: [{ required: true, message: "请输入加盟商" }],
        shopids: [{ required: true, message: "请输入门店" }],
        remark: [{ required: true, message: "请输入备注" }]
      }
    };
  },
  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.ruleForm.agentid = x.selectedAgent.agentid;
      this.ruleForm.vendorid = x.selectedVendor.vendorid;
      this.ruleForm.shopid = x.selectedShop.shopid;
    },

    initHandler(x) {
      console.log("initHandler", x);
      this.ruleForm.agentid = x.selectedAgent.agentid;
      this.ruleForm.vendorid = x.selectedVendor.vendorid;
      this.ruleForm.shopid = x.selectedShop.shopid;
    },
    translateItem(item) {
      switch (item) {
        case 1:
          return "周一";
        case 2:
          return "周二";
        case 4:
          return "周三";
        case 8:
          return "周四";
        case 16:
          return "周五";
        case 32:
          return "周六";
        case 64:
          return "周日";
        default:
          return "";
      }
    },
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.ruleForm.startTime = this.ruleForm.timeRange[0];
          this.ruleForm.endTime = this.ruleForm.timeRange[1];
          this.ruleForm.day = this.ruleForm.checkedWeek.reduce((total, num) => {
            return total + num;
          }, 0);
          this.$axios(
            this.$urlMapping[this.isCreate ? "新增定时促销" : "更新定时促销"],
            {
              data: {
                ...this.ruleForm
              }
            }
          ).then(() => {
            this.closeForm();
            this.$emit("refreshData");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    }
  },

  async mounted() {
    if (!this.isCreate) {
      this.selectedAvs = {
        selectedAgentid: this.promotionItem.agentid,
        selectedVendorid: this.promotionItem.vendorid,
        selectedShopid: this.promotionItem.shopid
      };
      console.log(this.selectedAvs);
    }
  }
};
</script>

<style lang="less" scoped></style>
